import { Breadcrumb, IBreadcrumbItem } from '@sanlam-glacier/app-common/components';
import { UIMatch, useMatch, useMatches, useNavigate } from 'react-router-dom';
import { useAuth } from 'auth';
import style from './page-breadcrumbs.module.scss';
import { clsx } from 'clsx';

type Handle = {
  breadcrumb?: {
    text: string;
    navigationPath: string;
    onClick: ((e: React.SyntheticEvent) => void) | undefined;
  };
};

export const PageBreadcrumbs = () => {
  const auth = useAuth();
  const matches = useMatches() as UIMatch<unknown, Handle>[];
  const navigate = useNavigate();
  const isDashboard = useMatch('/dashboard');
  const clientNavigationPath = '/clients/:clientId';
  const isClientDashboard = useMatch(clientNavigationPath);

  let crumbs = matches
    .filter((match) => Boolean(match.handle?.breadcrumb))
    .map((crumb) => crumb.handle.breadcrumb!);

  crumbs = crumbs.map((crumb) => ({
    ...crumb,
    onClick: crumb.navigationPath ? () => navigate(crumb.navigationPath) : undefined
  }));

  if (auth.identificationState === 'unidentified') {
    return null;
  }

  crumbs = crumbs.map((crumb) => ({
    ...crumb,
    onClick: crumb.navigationPath ? () => navigate(crumb.navigationPath) : undefined
  }));

  const breadcrumbItems: IBreadcrumbItem[] = crumbs.map((crumb) => ({
    label: crumb.text,
    onClick: crumb.onClick,
    limitWidth: false
  }));

  if (breadcrumbItems.length > 0) {
    breadcrumbItems.at(-1)!.className = clsx(style.currentPageCrumb);
  }

  return (
    <div
      className={
        isDashboard || isClientDashboard
          ? style.dashboardBreadcrumbContainer
          : style.pageBreadcrumbContainer
      }
    >
      <Breadcrumb
        crumbSize={2}
        crumbStart={2}
        className={style.pageBreadcrumbBody}
        crumbs={breadcrumbItems}
      />
    </div>
  );
};
